
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as exposed from '../exposed'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * OrderRequestSource enum
 */
class OrderRequestSource {
  /**
   * Initialize enum with a given value
   * @param {OrderRequestSource|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof OrderRequestSource) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!OrderRequestSource}
   * @param {!OrderRequestSource} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof OrderRequestSource)) {
      throw new TypeError('Instance of OrderRequestSource is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!OrderRequestSource}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!OrderRequestSource}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === OrderRequestSource.UNKNOWN.value) {
      return 'UNKNOWN'
    }
    if (this.value === OrderRequestSource.MOBILE_APP.value) {
      return 'MOBILE_APP'
    }
    if (this.value === OrderRequestSource.WEB_TRADER.value) {
      return 'WEB_TRADER'
    }
    if (this.value === OrderRequestSource.MANAGER.value) {
      return 'MANAGER'
    }
    if (this.value === OrderRequestSource.SOCIAL_TRADING.value) {
      return 'SOCIAL_TRADING'
    }
    if (this.value === OrderRequestSource.TRADING_API.value) {
      return 'TRADING_API'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!OrderRequestSource}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!OrderRequestSource}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!OrderRequestSource} Created enum
   */
  static fromObject (other) {
    return new OrderRequestSource(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
OrderRequestSource.UNKNOWN = new OrderRequestSource(0 + 0)
// noinspection PointlessArithmeticExpressionJS
OrderRequestSource.MOBILE_APP = new OrderRequestSource(0 + 1)
// noinspection PointlessArithmeticExpressionJS
OrderRequestSource.WEB_TRADER = new OrderRequestSource(0 + 2)
// noinspection PointlessArithmeticExpressionJS
OrderRequestSource.MANAGER = new OrderRequestSource(0 + 3)
// noinspection PointlessArithmeticExpressionJS
OrderRequestSource.SOCIAL_TRADING = new OrderRequestSource(0 + 4)
// noinspection PointlessArithmeticExpressionJS
OrderRequestSource.TRADING_API = new OrderRequestSource(0 + 5)

export { OrderRequestSource };

/**
 * Fast Binary Encoding OrderRequestSource field model
 */
class FieldModelOrderRequestSource extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelOrderRequestSource}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelOrderRequestSource}
   * @param {OrderRequestSource=} defaults Default value, defaults is new OrderRequestSource()
   * @returns {!OrderRequestSource} Result value
   */
  get (defaults = new OrderRequestSource()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new OrderRequestSource(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelOrderRequestSource}
   * @param {!OrderRequestSource} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelOrderRequestSource };
